import * as React from "react";

import { UitkLayoutGrid, UitkLayoutConditionalGridTrack } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";

import HotelCard from "../../../ImageLeftSmall/Layouts/GridLayout/HotelCard";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelsFlexModuleResult } from "typings/microserviceModels/hotels-flex-module";

interface GridLayoutProps {
  context: ExtendedContextStore;
  model: HotelsFlexModuleResult;
  columns: number & UitkLayoutConditionalGridTrack;
}

const GridLayout = (props: GridLayoutProps) => {
  const { context, model, columns } = props;
  const { hotels } = model;

  const keyHelper = new ItemKeyHelper("hotels");

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkLayoutGrid columns={columns} space="three">
        {hotels.map((hotel) => (
          <HotelCard key={keyHelper.next()} context={context} model={model} hotel={hotel} />
        ))}
      </UitkLayoutGrid>
    </UitkSpacing>
  );
};

export default GridLayout;
